import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import CurrencyBoard from './currencyBoard.js';
import ExchangeBoard from './exchangeBoard.js';
import ThemeSwitcher from './themeSwitcher.js';
import LeftHandPanel from './leftHandPanel.js';
import SidebarExampleDimmed from './settingsSideBar.js'
import ControlledTabs from './ControlledTabs.js'
import * as serviceWorker from './serviceWorker';
import AppSideBar from './reactSettingsSideBar.js'
import store from "./store/index";
import { addArticle } from "./actions/index";
import { updateTimeSettings } from "./actions/index";
import { Route, Link, BrowserRouter as Router } from 'react-router-dom'
import Login from './Login.js'
import Amplify from "aws-amplify";
import config from "./config/config.js"
import App from './App.js'
import { Auth } from "aws-amplify";
import { Provider } from "react-redux";


const routing = (
  <Router>
    <div>
      <Route path="/app" component={AppSideBar} />
      <Route path="/login" component={Login} />
    </div>
  </Router>
)

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

window.store = store.getState();
window.addArticle = addArticle;
window.updateTimeSettings = updateTimeSettings;



Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  }
});



//ReactDOM.render(<LeftHandPanel />, document.getElementById('lefthand-panel'));
//ReactDOM.render(<SidebarExampleDimmed />, document.getElementById('settings'));
ReactDOM.render(
<React.StrictMode>
<Provider store={store}>
  <Router>
    <App />
  </Router>
</Provider>
</React.StrictMode>,
  document.getElementById('exchange-boards')
);
//ReactDOM.render(routing, document.getElementById('exchange-boards'));

//ReactDOM.render(<ExchangeBoard firstCurrency="LKR" firstVal="23.23" secondCurrency="INR" secondVal="234.89"/>, document.getElementById('exchange-board'));
//ReactDOM.render(<ExchangeBoard firstCurrency="USD" firstVal="32.43" secondCurrency="EU" secondVal="28.25"/>, document.getElementById('exchange-board2'));
//ReactDOM.render(<ThemeSwitcher />,document.getElementById('exchange-board2'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
